export default __webpack_public_path__ + "static/media/1122.b52d7634.png";